// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// AWS Amplify imports
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

Vue.config.productionTip = false

// Init AWS Amplify
Amplify.configure({
  Auth: {
    identityPoolId: process.env.IDENTITY_POOL_ID,
    region: process.env.AWS_GLOBAL_REGION,
    identityPoolRegion: process.env.AWS_COGNITO_IDENTITY_REGION,
    mandatorySignIn: true
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: process.env.API_ENDPOINT,
        region: process.env.AWS_API_REGION
      }
    ]
  }
})
Vue.use(AmplifyPlugin, AmplifyModules)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js